export const MAX_CRYPTO_PRECISION = 18;
export const DEFAULT_BASE_CURRENCY = "btc";
export const DEFAULT_QUOTE_CURRENCY = "usd";
export const USD_PEGGED_STABLE_COINS = [
  "USDC",
  "USDT",
  "DAI",
  "GUSD",
  "BUSD"
  // Below coins aren't 1:1 pegged to USD
  // "MIM",
  // "UST",
];

export const TEST_IDS = {
  PRIMARY_INPUT_FIELD: "primary-input-field",
  PRIMARY_INPUT_CURRENCY_SELECTION_TRIGGER:
    "primary-input-currency-selection-trigger",
  SWAP_BUTTON: "swap-button",
  SECONDARY_INPUT_FIELD: "secondary-input-field",
  SECONDARY_INPUT_CURRENCY_SELECTION_TRIGGER:
    "secondary-input-currency-selection-trigger"
};
export const FIAT_CURRENCIES = ["USD", "SGD", "EUR", "GBP", "AUD"];

export const NUMBER_REGEX = /^\d*\.?\d*$/;
